const serverURL = import.meta.env.VITE_API_URL

export async function transcribeAudio(token: string, blob: Blob, filename: string): Promise<string> {
  const formData = new FormData()
  formData.append('file', blob, filename)

  const response = await fetch(`${serverURL}/stt/transcribe`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const data = await response.json()
  return data.text
}
